<template>
    <MenuDropDown
        :items="currencyItems"
        :label="current"
        class="menu-drop-down"
        :class="classSwitcher"
        @select="select(currencyItems[$event]?.currency)"
    />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import {
    type AppCurrency,
    useCurrency,
    useCurrencyPlugin,
} from '@/plugins/currency'
import {
    getIsActiveRegion,
    type RegionFragmentMap,
    useRegionPlugin,
} from '@/plugins/region'

import MenuDropDown, {
    type MenuDropDownItem,
} from '@/components/ui/menus/MenuDropDown.vue'

const { isInFooter } = defineProps<{
    isInFooter?: boolean
}>()

const { selectCurrency } = useCurrencyPlugin()
const { regions } = useRegionPlugin()

type DropDownItemWithCurrency = MenuDropDownItem & { currency: AppCurrency }
type GroupedCurrencyDropDownItems = {
    [K in AppCurrency]: DropDownItemWithCurrency
}

// TODO translate
const currencyItems = computed((): DropDownItemWithCurrency[] => {
    const regs: RegionFragmentMap = regions.value ?? ({} as RegionFragmentMap)

    const grouped: Partial<GroupedCurrencyDropDownItems> = {}

    for (const reg of Object.values(regs)) {
        if (reg && getIsActiveRegion(reg.code)) {
            grouped[reg.currency] = {
                label: reg.currency,
                currency: reg.currency,
            }
        }
    }

    return Object.values(grouped)
})

const current = useCurrency()

const select = (currency: AppCurrency | undefined) => {
    if (!currency) {
        return
    }

    selectCurrency(currency)
}

const classSwitcher = computed(() => ({
    'in-footer': isInFooter,
}))
</script>

<style lang="scss" scoped>
.menu-drop-down {
    &.in-footer {
        background: $stone-3;

        :deep(.menu-button) {
            color: $slate;
        }

        :deep(.menu) {
            right: 0;
            left: auto;

            background: $stone-2;

            .item {
                color: $slate;

                &:focus {
                    color: rgba($slate, 0.7);
                }

                @include hover() {
                    color: rgba($slate, 0.7);
                }
            }
        }
    }

    @include min-width(1024) {
        &:not(.in-footer) {
            :deep(.menu) {
                left: -10px;
                top: 30px;
                right: initial;
                bottom: initial;
            }
        }
    }

    @include min-width(1024) {
        background: $stone-2;

        :deep(.menu-button) {
            color: $slate;
        }

        :deep(.menu) {
            background: $stone-2;

            .item {
                color: $slate;

                &:focus {
                    color: rgba($slate, 0.7);
                }

                @include hover() {
                    color: rgba($slate, 0.7);
                }
            }
        }
    }
}
</style>
